import './WineDeliveryDisclaimer.scss'
import { ReactComponent as Icon } from '../../../assets/svg/wine-glass.svg'
import { useEffect } from 'react'
import { trackBannerViewed } from 'src/utils/tracking'

type Props = {
  size?: 'md' | 'lg' | 'xl'
  title?: string
  body?: string
  origin?:
    | 'wine_added_to_cart'
    | 'wine_added_in_confirmation_page'
    | 'wine_confirmed_order'
  showFreeDelivery?: boolean
}

const ICON_SIZES = {
  md: 16,
  lg: 24,
  xl: 24
}

export const WineDeliveryDisclaimer = ({
  size = 'md',
  title = 'This order contains wine',
  body,
  origin,
  showFreeDelivery
}: Props) => {
  useEffect(() => {
    trackBannerViewed(origin)
  }, [origin])

  return (
    <div
      className={`wine-delivery-disclaimer wine-delivery-disclaimer--${size}`}>
      <Icon
        className={`wine-delivery-disclaimer__icon wine-delivery-disclaimer__icon--${size}`}
        height={ICON_SIZES[size]}
        width={ICON_SIZES[size]}
      />
      <div>
        <span
          className={`wine-delivery-disclaimer__title wine-delivery-disclaimer__title--${size}`}>
          {title}
        </span>
        <span
          className={`wine-delivery-disclaimer__body wine-delivery-disclaimer__body--${size}`}>
          {body}
        </span>
        {showFreeDelivery && (
          <div className="wine-delivery-disclaimer__free-delivery-badge">
            <span>Enjoy free delivery in wine!</span>
          </div>
        )}
      </div>
    </div>
  )
}
